/**
 * @file    TableGrid.tsx
 * @scope   VIEW
 * @summary The DynamicTable data grid. Owns its UI-local sorting and pagination state.
 * @consumes DynamicTableStyledDataGrid
 * @produces JSX only
 * @sideEffects None.
 */
import React, { useState } from 'react';
import { PaginationState, SortingState } from '@cx/ui';
import { DynamicTableStyledDataGrid } from 'features/DataGrid/DataGridStyling';
import { joinClasses } from '../../common/utils/tableLayout';

export interface TableGridProps {
  columns: any[];
  data: any[];
  striped?: boolean;
  showTotals?: boolean;
  pagination?: boolean;
  loading?: boolean;
}

const TableGrid: React.FC<TableGridProps> = ({
  columns,
  data,
  striped,
  showTotals,
  pagination,
  loading,
}) => {
  const [sorting, setSorting] = useState<SortingState>([]);
  const [paginationState, setPaginationState] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  return (
    <DynamicTableStyledDataGrid
      className={joinClasses('dynamic-table', striped && 'stripted', showTotals && 'show-totals')}
      columns={columns}
      data={data}
      pagination={paginationState}
      paginationOptions={{
        onPaginationChange: setPaginationState,
        rowCount: data.length,
        manualPagination: false,
      }}
      enablePagination={pagination}
      sorting={sorting}
      sortingOptions={{
        onSortingChange: setSorting,
        enableSorting: true,
        enableSortingRemoval: false,
      }}
      isLoading={loading}
    />
  );
};

export default React.memo(TableGrid);
